import React from 'react'
import StatusCards from './StatusCards'
import ServiceStatusTable from './ServiceStatusTable'
import useSystemStatus from '../hooks/useSystemStatus'

const SystemStatus = () => {
  const { services, isLoading } = useSystemStatus()

  return (
    <div>
      <div className="sm:mx-2 py-4 mb-4 border-b border-content/40 border-dashed">
        <div className="flex justify-between items-start">
          <div>
            <h1 className="text-xl font-bold text-primary">
              System Status
            </h1>
            <p className="text-sm text-muted mt-1">
              Check real-time status for all services
            </p>
          </div>
        </div>
      </div>
      
      <StatusCards services={services} />
      
      <ServiceStatusTable services={services} loading={isLoading} />
    </div>
  )
}

export default SystemStatus
